import { Container, Stack, Typography, Box, Link } from '@mui/material';
import React, { FC } from 'react';
import ScrollToTop from '../../../components/layout/ScrollToTop';

const Accessiblity: FC<{}> = () => {
	return (
		<>
			<ScrollToTop />
			<Container>
				<Stack spacing={2}>
					<Typography variant="h2" component={'h1'}>
						Erklärung zur Barrierefreiheit
					</Typography>
					<br />
					<Box>
						<Typography>
							<em>Der Verband der Musik- und Kunstschulen Brandenburg e. V.</em> setzt sich dafür ein, die digitale Barrierefreiheit für Menschen mit Behinderungen zu gewährleisten. Wir verbessern kontinuierlich die Benutzerfreundlichkeit für alle und wenden die entsprechenden Standards für die Zugänglichkeit an. Diese Erklärung zur digitalen Barrierefreiheit gilt für die Website antragsportal.vdmk-brandenburg.de <br /> <br />

							Der Verband der Musik- und Kunstschulen Brandenburg e. V. ist bemüht, diese Website im Einklang mit den Bestimmungen des Brandenburgischen Behindertengleichstellungsgesetzes (BbgBGG) sowie der Brandenburgischen Barrierefreie Informationstechnik-Verordnung (BbgBITV) zur Umsetzung der Richtlinie (EU) 2016/2102 barrierefrei zugänglich zu gestalten. <br /> <br />

							Gemäß § 2 BbgBITV wird angenommen, dass Webauftritte und Apps barrierefrei sind, wenn die Anforderungen der harmonisierten Europäischen Norm (EN) 301 549 (in der aktuellen Version) erfüllt sind. Die EN 301 549 verweist auf die Anforderungen des internationalen Standards der Web Content Accessibility Guidelines der Version 2.1 (WCAG 2.1) mit den Konformitätsstufen A und AA. Diese Anforderungen bilden den Kern der prüfbaren Erfolgskriterien ab.
						</Typography>
					</Box> <br />

					<Box>
						<Typography variant="h5" component="h4">
							Bemühungen zur Unterstützung der Barrierefreiheit
						</Typography>
						<Typography>
							<em>Der Verband der Musik- und Kunstschulen Brandenburg e. V.</em> ergreift die folgenden Maßnahmen, um die Zugänglichkeit zu gewährleisten:
							<ul>
								<li>Innerhalb des Unternehmens gibt es klare Ziele und Verantwortlichkeiten für die Barrierefreiheit.</li>
								<li>Die Barrierefreiheit unserer Internetangebote wird regelmäßig auf Barrierefreiheit geprüft.</li>
								<li>Formale Methoden zur Qualitätssicherung der Zugänglichkeit existieren innerhalb des Unternehmens.</li>
							</ul>
						</Typography>
					</Box> <br />

					<Box>
						<Typography variant="h5" component="h4">
							Stand der Vereinbarkeit mit den Anforderungen
						</Typography>
						<Typography>
							Die Website ist mit der harmonisierten Europäischen Norm (EN) 301 549 (in der aktuellen Version) zu großen Teilen vereinbar.
						</Typography>
					</Box> <br />

					<Box>
						<Typography variant="h5" component="h4">
							Nicht barrierefreie Inhalte
						</Typography>
						<Typography>
							Trotz unserer Bemühungen können bei den Benutzern einige Probleme auftreten. Bitte kontaktieren Sie uns, wenn Sie einen nicht barrierefreien Inhalt festgestellt haben, der hier aufgeführt werden muss.
						</Typography>
					</Box><br />

					<Box>
						<Typography variant="h5" component="h4">
							Kompatibilität mit Browsern und unterstützenden Technologien
						</Typography>
						<Typography>
							Diese Website ist so konzipiert, dass sie mit den folgenden Browsern kompatibel ist:
							alle gängigen Browser in der aktuellen Version und mindestens deren Vorgängerversion:
							<ul>
								<li>Internet Explorer (Windows) Versionen 7.0 bis 11.0</li>
								<li>Microsoft Edge</li>
								<li>Mozilla Firefox</li>
								<li>Google Chrome</li>
								<li>Safari</li>
							</ul>

						</Typography>
						<Typography>
							Diese Website ist so konzipiert, dass sie mit den folgenden unterstützenden Technologien kompatibel ist:
							<ul>
								<li>JAWS Screen Reader</li>
							</ul>
						</Typography>
					</Box>

					<Box>
						<Typography variant="h5" component="h4">
							Technologien
						</Typography>
						<Typography>
							Die Barrierefreiheit dieser Webseite hängt von den folgenden Technologien ab, um zu funktionieren:
							<ul>
								<li>HTML</li>
								<li>WAI_ARIA</li>
								<li>CSS</li>
								<li>Javascript</li>
								<li>SMIL</li>
							</ul>
						</Typography>
					</Box>

					<Box>
						<Typography variant="h5" component="h4">
							Bewertungsmethoden
						</Typography>
						<Typography>
							Der Verband der Musik- und Kunstschulen Brandenburg e. V.  hat die Barrierefreiheit dieser Website mit Hilfe einer internen Selbsteinschätzung bewertet.
						</Typography>
					</Box><br />

					<Box>
						<Typography variant="h5" component="h4">
							Feedback und Kontaktangaben
						</Typography>
						<Typography>
							Wir freuen uns über Ihr Feedback zur Barrierefreiheit dieser Website. Bitte kontaktieren Sie uns auf eine der folgenden Arten: <br />
							Telefon: <em>0331-2016470</em> <br />
							E-Mail: <em><Link href={'mailto:kontakt@vdmk-brandenburg.de'}>kontakt@vdmk-brandenburg.de</Link></em> <br />
							Firmenanschrift: <em>Verband der Musik- und Kunstschulen e. V., Schiffbauergasse 4b, 14467 Potsdam</em> <br />
							Wir werden Ihnen innerhalb von drei Wochen eine Rückmeldung geben.
						</Typography>
					</Box><br />

					<Box>
						<Typography variant="h5" component="h4">
							Durchsetzungsverfahren
						</Typography>
						<Typography>
							Sollten Sie innerhalb eines Zeitraums von drei Wochen eine nicht zufriedenstellende oder keine Antwort aus oben genannter Kontaktmöglichkeit erhalten, können Sie sich an die Durchsetzungsstelle für digitale Barrierefreiheit des Landes Brandenburg zur Prüfung der in der Erklärung zur Barrierefreiheit genannten Angaben und Maßnahmen wenden. Die Durchsetzungsstelle hat nach § 4 Abs. 3 BbgBITV die Aufgabe, das Recht der <br />

							Bürgerinnen und Bürger auf barrierefrei gestaltete Websites und mobile Anwendungen gegenüber öffentlichen Stellen des Landes Brandenburg durchzusetzen. <br />

							Die Durchsetzungsstelle prüft aus formaler und inhaltlicher Sicht die Anwendbarkeit eines Durchsetzungsverfahrens und ordnet im Einzelfall eine technische Überprüfung der Website oder mobilen Anwendung bei der Überwachungsstelle für Barrierefreiheit von Web- und Anwendungstechnologien im Land Brandenburg an. Das Durchsetzungsverfahren ist kostenlos. Es muss kein Rechtsbeistand eingeschaltet werden.

						</Typography>
					</Box><br />

					<Box>
						<Typography variant="h5" component="h4">
							Kontakt
						</Typography>
						<Typography>
							Ministerium für Soziales, Gesundheit, Integration und Verbraucherschutz
							des Landes Brandenburg – Landesbehindertenbeauftragte | Durchsetzungsstelle für digitale Barrierefreiheit <br />
							Henning-von-Tresckow-Straße 2-13, Haus S <br />
							14467 Potsdam <br />
							E-Mail: <Link href={'mailto:Durchsetzung.BIT@MSGIV.Brandenburg.de'}>Durchsetzung.BIT@MSGIV.Brandenburg.de</Link> <br />
							Telefon: 0331/866-5048

						</Typography>
					</Box><br />


				</Stack>
				<Typography>
					Stand: 25.08.2025
				</Typography>
			</Container>
		</>
	);
};
export default Accessiblity;

